import { AuthRepository } from '../repositories/AuthRepository';


export class Renew {
  constructor(private repository: AuthRepository) {}

  execute(): Promise<void> {
    return this.repository.renew();
  }
}
